// Navigation

import Listrak from "../Listrak"
import { log } from "../Log"

export const goToCart = async () => {
  Listrak.listrakEmptyCart()
  location.href = '/cart.php'
}

export const goToHome = async () => {
  location.href = '/'
}

export const goToConfirmation = (orderId) => {
  log('goToConfirmation: Going to checkout with orderId ', orderId)
  location.href = `/checkout/order-confirmation/${orderId}`
}

export const setPageTitle = (title) => {
  document.title = `One Kings Lane ${title}`
}

export const setCustomerLocalStorage = async ({ customerId, customerEmail }) => localStorage.setItem('customer', JSON.stringify({ customerId, customerEmail }))

export const getPageUrl = async () => location.href
/**
 * Update the path to the specified string. Either absolute or relative to
 * the root, without triggering a page fresh.
 */
export const updateCurrentPathTo = (path) => history.pushState({}, undefined, path)

export const reloadPage = () => {
  window.location.reload()
}
